
import { useEffect, useState } from "react";
import type { UniClub as Club } from "../types";
import { dedupeClubs } from "../lib/dedup";

export function useClubs() {
  const [clubs, setClubs] = useState<Club[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClubs = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch("/judoclubs/ffj.json");
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data: Club[] = await res.json();
      // ✅ Dédoublonnage ici
      console.log(`Fetched ${data.length} clubs, deduplicating...`);
      const unique = dedupeClubs(data);
      console.log(`Returned ${unique.length} unique clubs...`);

        setClubs(unique);
      } catch (e: any) {
        setError(e?.message ?? "Erreur inconnue");
      } finally {
        setLoading(false);
      }
    };
    fetchClubs();
  }, []);

  return { clubs, loading, error };
}
``
